import Model from "./base/model";

class ShipperTableModel extends Model {
  resourceName() {
    return "shipper_table_model";
  }

  fields() {
    return {
      shipper_id: "",
      table_model: "",
      shipper: { jsonApi: "hasOne", type: "shippers" },
    };
  }

  async createTableModel(data) {
    return this.request(
      "shippers/table_model",
      "POST",
      {},
      data
    );
  }

  async updateTableModel(id, data) {
    return this.request(
      "shippers/table_model/" + id,
      "PATCH",
      {},
      data
    );
  }

}

export default new ShipperTableModel();
